// Accepts any admin-curated game-group slug (API-controlled, not a fixed enum like `category`/`provider`).
export const match = (param: string) => /^[a-z0-9-]+$/.test(param);
